
import { combineReducers } from 'redux'
import {
    ACTION_SET_BOOKS,
     ACTION_DELETE_BOOK,
    ACTION_SET_USER_INFO
} from './actions'
import Home from 'pages/home/store/reducer';
const reducers = combineReducers({
    ...Home,
    user_info(state = {}, action) {
        const { type, payload } = action;
        switch (type) {
            case ACTION_SET_USER_INFO:
                return payload
        }
        return state;
    },

    books(state = [], action) {
        const { type, payload } = action;
        switch (type) {
            case ACTION_SET_BOOKS:
                return payload
            case ACTION_DELETE_BOOK:
                const new_state = state.slice();
                new_state.splice(payload, 1);
                return new_state
        }
        return state;
    }
})
export default reducers